import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import NavHeader from './NavHeader';
import Sidebar from './Sidebar';
import SidebarOverlay from './SidebarOverlay';
import BirthdayGreeting from '../common/BirthdayGreeting';
import AcademicAssistant from '../AcademicAssistant';

const Layout = () => {
    return (
        <div id="main-wrapper">
            <NavHeader />
            <Header />
            <Sidebar />
            <SidebarOverlay />
            <BirthdayGreeting />
            <AcademicAssistant />

            <div className="content-body">
                <div className="container-fluid">
                    <Outlet />
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Layout;
